export default __webpack_public_path__ + "public/images/services/Shield.png?b81cc232";